/* @flow */

import $ from 'jquery';
import { ConnectedRouter } from 'connected-react-router';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { hot } from 'react-hot-loader';
import { renderRoutes } from 'react-router-config';
import React from 'react';

import { AvatarContext, genRuby } from '@sonyged/ext-proc';
import { GlobalStyle, defaultTheme } from '@sonyged/proc-ui';

import type { ErrorType } from '../redux/reducer/meta';
import { Prefetcher, routes } from './routes';
import type { StoreState } from '../redux/types';
import { contest } from '../redux/selector';
import { history } from '../redux/store';
import AppContext from '../AppContext';
import BGMPath1 from '../../assets/sounds/proc-bgm1.mp3';
import BGMPath2 from '../../assets/sounds/proc-bgm2.mp3';
import BGMPath3 from '../../assets/sounds/proc-bgm3.mp3';
import BGMPath4 from '../../assets/sounds/proc-bgm4.mp3';
import BGMPath5 from '../../assets/sounds/proc-bgm5.mp3';
import ErrorModal from './ErrorModal';
import RotateImage from '../../assets/images/common/rotate@3x.png';
import SEPath from '../../assets/sounds/proc-se.mp3';
import SoundController from '../utils/SoundController';
import UPParser from 'ua-parser-js';

import { ThemeProvider } from 'styled-components';

type Props = {
  avatar: ?string,
  mute: boolean,
  pizzaUid: ?string,
  iceUid: ?string,
  error: ?ErrorType,
};

type State = {
  showOrientationPopup: boolean,
};

const isMobileOS = () => {
  let parser = new UPParser();

  let os = parser.getOS();
  if (os) {
    if (os.name == 'iOS' || os.name == 'Android') {
      return true;
    }
  }

  return false;
};

class App extends React.Component<Props, State> {
  mql: ?MediaQueryList;
  ctx: { soundController: SoundController };

  constructor(props: Props) {
    super(props);
    let soundController = null;
    soundController = new SoundController([BGMPath1, BGMPath2, BGMPath3, BGMPath4, BGMPath5], SEPath);

    soundController.mute(props.mute);
    this.ctx = { soundController: soundController };

    this.state = {
      showOrientationPopup: false,
      avatarSelectorOpened: false,
    };

    (this: any).screenTest = this.screenTest.bind(this);
    (this: any).playSE = this.playSE.bind(this);
  }

  componentDidMount() {
    const mql = window.matchMedia('(max-width: 896px) and (orientation:landscape)');
    this.mql = mql;

    if (isMobileOS()) {
      mql.addListener(this.screenTest);
      this.screenTest(mql);
    }

    requestAnimationFrame(() => {
      this.forceUpdate();
    });

    // mute when browser goes to background.
    window.addEventListener(
      'focus',
      () => {
        this.ctx.soundController.mute(this.props.mute);
      },
      false
    );
    window.addEventListener(
      'blur',
      () => {
        this.ctx.soundController.mute(true);
      },
      false
    );

    document.addEventListener('click', this.playSE);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.playSE);

    if (!this.mql) return;

    this.mql.removeListener(this.screenTest);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.mute !== prevProps.mute) {
      this.ctx && this.ctx.soundController.mute(this.props.mute);
    }
  }

  screenTest(e: any) {
    if (e.matches) {
      // width < 992px & 横長
      this.setState({ showOrientationPopup: true });
    } else {
      this.setState({ showOrientationPopup: false });
    }
  }

  playSE(e: MouseEvent) {
    const $target = $(e.target);

    if ($target.closest('.proc-btn.disabled, .proc-button.disabled, .proc-button.proc-button--disabled').length) {
      // do nothing
    } else if ($target.closest('.proc-image-selection-container .images-container').length) {
      // choice
      this.ctx.soundController.sePlay('choice01');
    } else if ($target.closest('.radio-button, .proc-choice-se').length) {
      // choice
      this.ctx.soundController.sePlay('choice01');
    } else if ($target.closest('.proc-menu-container, .modal-open-se').length) {
      this.ctx.soundController.sePlay('modal_open');
    } else if ($target.closest('.modal-close-se').length) {
      this.ctx.soundController.sePlay('modal_close');
    } else if ($target.closest('.proc-btn.play-se, .proc-button.play-se').length) {
      // play button
      this.ctx.soundController.sePlay('jikkou');
    } else if ($target.closest('.proc-conversation .proc-footer .proc-button').length) {
      // chat next button
      this.ctx.soundController.sePlay('chatSE01');
    } else if ($target.closest('.proc-button.icon').length) {
      this.ctx.soundController.sePlay('proc_SE02');
    } else if ($target.closest('a, .proc-btn, .proc-button, .proc-select, .option-item, .proc-button-se').length) {
      // button
      this.ctx.soundController.sePlay('proc_SE01');
    }
  }

  render() {
    const { avatar, error } = this.props;
    return (
      <ThemeProvider theme={defaultTheme}>
        <AppContext.Provider value={this.ctx}>
          <AvatarContext.Provider value={avatar}>
            <GlobalStyle />
            <div className={'w100 h100'}>
              <ConnectedRouter history={history}>
                <div id="proc-page-root" className="proc-mainPage proc">
                  <Prefetcher>{renderRoutes(routes)}</Prefetcher>
                  {error && <ErrorModal error={error} />}
                </div>
              </ConnectedRouter>

              {this.state.showOrientationPopup && this.renderOrientationNotice()}
            </div>
          </AvatarContext.Provider>
        </AppContext.Provider>
      </ThemeProvider>
    );
  }

  renderOrientationNotice() {
    //TODO [画|が]めんを たてに してね。
    return (
      <div className="proc-orientation-notice">
        <div className={'content-container'}>
          <img className={'image'} src={RotateImage} />
          <div className={'title proc-large-font gray100-color'}>
            {this.props.pizzaUid ? genRuby('がめんを たてに してね。') : 'がめんを たてに してね。'}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: StoreState) => {
  return {
    avatar: get(state, 'profile.avatar'),
    mute: state.config.mute,
    pizzaUid: contest.pizza.contestUid(state),
    iceUid: contest.ice.contestUid(state),
    error: state.meta.error,
  };
};

export default hot(module)(connect<Props, {||}, _, _, _, _>(mapStateToProps)(App));
